import { render } from "./ClientesView.vue?vue&type=template&id=4fc7e474&scoped=true"
import script from "./ClientesView.vue?vue&type=script&lang=js"
export * from "./ClientesView.vue?vue&type=script&lang=js"

import "./ClientesView.vue?vue&type=style&index=0&id=4fc7e474&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc7e474"]])

export default __exports__